import clsx from "clsx";
import Spinner from "./spinner";
//extends React.ButtonHTMLAttributes<HTMLButtonElement>
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  loading?: boolean;
  type?: "submit" | "reset" | "button";
}

export function Button({
  children,
  className,
  type = "submit",
  loading,
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      {...rest}
      className={clsx(
        "flex h-10 items-center justify-center rounded-lg px-4 text-sm font-medium transition-colors",
        {
          "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600 active:bg-purple-700 aria-disabled:cursor-not-allowed aria-disabled:opacity-50  bg-purple-600 text-white hover:bg-purple-700":
            type === "submit",
          "hover:bg-gray-200 bg-gray-100 text-gray-600": type == "reset",
        },
        className
      )}
    >
      {loading ? (
        <span className="flex gap-2">
          <Spinner visible size="small" />
          Saving...
        </span>
      ) : (
        children
      )}
    </button>
  );
}
